import { render } from "./App.vue?vue&type=template&id=2f317a6f"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2f317a6f&lang=css"
script.render = render

export default script